import React from 'react';
import PropTypes from 'prop-types';
import { useForm, FormProvider } from 'react-hook-form';
import { SelectField, NumberSliderField } from 'components/formFields';

const Filters = ({
  countyChoices = [],
  canSubmit = true,
  onSubmit,
}) => {
  const defaultValues = {
    radius: 100,
    county_id: null,
    name: 0,
    street: 0,
  };

  const formMethods = useForm({
    mode: 'onTouched',
    defaultValues,
  });

  const handleResetClick = () => {
    formMethods.reset(defaultValues);
  };

  return (
    <FormProvider {...formMethods}>
      <form
        className="d-flex align-items-center flex-wrap"
        style={{ gap: 15 }}
        onSubmit={formMethods.handleSubmit(onSubmit)}
      >
        <div style={{ flex: '0 0 250px' }}>
          <SelectField
            name="county_id"
            label="County"
            choices={countyChoices}
          />
        </div>

        <div style={{ flex: 1, minWidth: 100 }}>
          <NumberSliderField
            name="radius"
            label="Distance Radius"
            valueLabelSuffix=" meters"
            min={20}
            max={1000}
            step={20}
          />
        </div>

        <div style={{ flex: 1, minWidth: 100 }}>
          <NumberSliderField
            name="name"
            label="Name Similarity"
            valueLabelSuffix="%"
          />
        </div>

        <div style={{ flex: 1, minWidth: 100 }}>
          <NumberSliderField
            name="street"
            label="Address Similarity"
            valueLabelSuffix="%"
          />
        </div>

        <button type="button" className="btn-z outline ms-2" onClick={handleResetClick}>Reset Filters</button>
        <input type="submit" value="Run Report" className="btn-z primary" disabled={!canSubmit} />
      </form>
    </FormProvider>
  );
};

Filters.propTypes = {
  countyChoices: PropTypes.array,
  canSubmit: PropTypes.bool,
  onSubmit: PropTypes.func,
};

export default Filters;
